import { useEffect, useRef, useState, useCallback } from "react";

export function useTurnstile({
  sitekey = "0x4AAAAAACE2Jp6L7wKno3E8",
  theme = "light",
} = {}) {
  const containerRef = useRef(null);
  const widgetIdRef = useRef(null);

  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);
  const [failover, setFailover] = useState(false);

  const renderWidget = useCallback(() => {
    if (!window.turnstile || !containerRef.current) return;

    // eliminar widget previo
    if (widgetIdRef.current !== null) {
      try {
        window.turnstile.remove(widgetIdRef.current);
      } catch (_) {}
    }

    widgetIdRef.current = window.turnstile.render(containerRef.current, {
      sitekey,
      theme,
      callback: (token) => {
        setToken(token);
        setFailover(false);
      },
      "expired-callback": () => {
        setToken(null);
      },
      "error-callback": () => {
        setToken(null);
      },
    });
  }, [sitekey, theme]);

  const reset = useCallback(() => {
    setToken(null);
    renderWidget(); // 🔥 CLAVE
  }, [renderWidget]);

  useEffect(() => {
    let timeoutId;

    if (!window.turnstile) {
      timeoutId = setTimeout(() => {
        if (!window.turnstile) {
          setFailover(true);
          setLoading(false);
        }
      }, 2000);
      return;
    }

    renderWidget();
    setLoading(false);

    return () => {
      clearTimeout(timeoutId);
      if (window.turnstile && widgetIdRef.current !== null) {
        try {
          window.turnstile.remove(widgetIdRef.current);
        } catch (_) {}
      }
    };
  }, [renderWidget]);

  return {
    containerRef,
    token,
    loading,
    failover,
    reset,
  };
}

